module.exports = __webpack_public_path__ + "static/media/blue@3x.97677702.png";